export const aciCloseStrong = {
    iconName: 'close-strong',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 34 35' },
        path: {
            attr: {
                d: 'M9.045 9.62l15.91 15.91M24.955 9.62L9.045 25.53',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
